var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AwsUi } from '../../../core/runtime/src';
import LegacyClassBuilder from '../../../core/utils/src/class-builders/legacy';
import { Button } from '../../button/src';
import { Icon } from '../../icon/src';
import { Spinner } from '../../spinner/src';
export var Flash = AwsUi.__addComponent('awsui-flash', {
    releaseStatus: 'deprecated',
    events: {
        // Fired when the user clicks on the close icon that is displayed
        // when the `dismissible` property is set to `true`.
        dismiss: {
            cancelable: true
        },
        // Fired when the user clicks on the action button.
        buttonClick: {
            cancelable: false
        }
    },
    properties: {
        // Indicates the type of the message to be displayed.
        type: {
            nullable: false,
            valid: ['success', 'error', 'warning', 'info'],
            defaultValue: 'info'
        },
        // Replaces the icon with a spinner and forces the type of alert to `info`.
        loading: {
            type: 'boolean'
        },
        // Determines whether the message is displayed to the user or not.
        visible: {
            type: 'boolean',
            defaultValue: true,
            onChange: function () {
                AwsUi.stickyElements.notify(this.node);
            }
        },
        // If true, the component will include a close button in the UI.
        // By default, the close button is not included in the UI.
        //
        // Clicking on this button will fire the `awsui:dismiss` event and will set the `visible` property to false.
        dismissible: {
            type: 'boolean',
            nullable: true
        },
        // When set, an action button will be displayed in the message area
        // and the close button will also be displayed, unless the `dismissible` property
        // is explicitly set to `false`.
        //
        // An`awsui:buttonClick` event will be triggered when the user clicks on it.
        buttonText: {
            type: 'string'
        },
        // Adds an `aria-label` to the dismiss button for better accessibility
        dismissLabel: {
            type: 'string'
        }
    },
    regions: {
        // Heading text.
        header: {},
        // Primary text displayed in the element.
        content: {
            isDefault: true
        }
    },
    render: function (m, h) {
        var _this = this;
        var dismissButton = function () {
            if (!_this.dismissible) {
                return;
            }
            var dismissFn = function () {
                _this.__fireEvent('dismiss', null, {
                    onNotCanceled: function () { return (_this.visible = false); }
                });
            };
            var attributes = {
                variant: 'icon',
                icon: 'close',
                formAction: 'none',
                click: dismissFn,
                label: _this.dismissLabel
            };
            return (AwsUi.__createElement("div", { className: "awsui-flash-dismiss" },
                AwsUi.__createElement(Button, __assign({}, attributes))));
        };
        var actionButton = function () {
            if (!_this.buttonText) {
                return;
            }
            var trigger = function () { return _this.__fireEvent('buttonClick'); };
            return AwsUi.__createElement(Button, { text: _this.buttonText, click: trigger, className: "awsui-flash-action-button", formAction: "none" });
        };
        var iconType = {
            success: 'status-positive',
            warning: 'status-warning',
            info: 'status-info',
            error: 'status-negative'
        }[this.type];
        var icon = this.loading ? AwsUi.__createElement(Spinner, null) : AwsUi.__createElement(Icon, { name: iconType });
        var cb = new LegacyClassBuilder(this)
            .addClass('awsui-flash')
            .addClass('awsui-flash-hidden', !this.visible)
            .addClass('awsui-flash-type-info', this.loading)
            .addPropertyValueClass('type', !this.loading);
        return (AwsUi.__createElement("div", { className: cb.toClassName(), "aria-hidden": !this.visible },
            AwsUi.__createElement("div", { className: "awsui-flash-icon" }, icon),
            AwsUi.__createElement("div", { className: "awsui-flash-body" },
                AwsUi.__createElement("div", { className: "awsui-flash-message" },
                    h.region('header', 'div', { className: 'awsui-flash-header' }),
                    h.region('content', 'div')),
                actionButton()),
            dismissButton()));
    }
});
//# sourceMappingURL=flash.js.map